import { Box, Button, Container, Text } from "@chakra-ui/react"
import ErrorHermeli from "../../../public/assets/images/wz-hermeli-error-white.png"
import { useRouter } from "@tanstack/react-router"

const AuthorError = () => {
  const router = useRouter()

  return (
    <Container
      textAlign="center"
    >
      <Text
        fontSize="5xl"
        color="main"
        fontWeight="bold"
        mb={4}
      >
        Dieser Autor hat kein öffentliches Profil!
      </Text>

      <Box
        bgImage={`url(${ErrorHermeli})`}
        bgRepeat="no-repeat"
        bgSize="contain"
        bgPos="top"
        h="20em"
        w="auto"
        display="block"
        mt={5}
      />

      <Button
        color="main"
        borderColor="main"
        variant="outline"
        mt={4}
        size="lg"
        textDecor="none"
        onClick={() => router.history.back()}
      >
        Zurück
      </Button>
    </Container>
  )
}

export default AuthorError
